import { Button, ButtonGroup, Dialog, Fade, Grid, Typography, Zoom } from "@mui/material";
import i18n from "../reducers/i18n";
import SortableDragAndDrop from "./SortableDragAndDrop/SortableDragAndDrop";
import NotificationTypesFilter from "./SortableDragAndDrop/Filters/NotificationTypesFilter";
import { useEffect, useState } from "react";
import AreaPoolFilter from "./SortableDragAndDrop/Filters/AreaPoolFilter";
import UsersFilter from "./SortableDragAndDrop/Filters/UsersFilter";
import { connect } from "react-redux";
import { Add, TabletMacRounded } from "@mui/icons-material";
import { getalluser } from "../actions/user";
import Skeliton from "./SortableDragAndDrop/Skeliton";
import { Link } from "react-router-dom";

import { ReactComponent as KompactSvg } from "../assets/Compact.svg";
import { ReactComponent as DetailsSvg } from "../assets/Details.svg";

import { ReactComponent as FokusSvg } from "../assets/Focus.svg";
import { ReactComponent as StandardSvg } from "../assets/Standard.svg";


export default connect(
  ({ users, subscribedSites }) => ({
    users, subscribedSites
  }),
  {
    getalluser,
  }
)((props) => {

  // header filters

  const [FilterNotificationTypes, setFilterNotificationTypes] = useState([
    "all",
  ]);

  const [areaPoolFilterValue, setAreaPoolFilterValue] = useState();

  const [userFilter, setUserFilter] = useState([
    "all",
  ]);

  const [isFocused, setIsFocused] = useState(false); // switch between standard and fokused view

  const [viewMode, setViewMode] = useState("d");   // d = Detail view , c = Compact view

  const [showSkeliton, setShowSkeliton] = useState(true);

  useEffect(() => {
    props.getalluser();
    setTimeout(() => {
      setShowSkeliton(false);
    }, 2000)
  }, []);


  // setting default value (first site) of area pool filters 
  useEffect(() => {
    if (Object.keys(props.subscribedSites).length) {
      setAreaPoolFilterValue("s==>" + Object.values(props.subscribedSites)[0].nodeid);
    }
  }, [props.subscribedSites]);

  return (
    <>
{/* Dialog for fokus view */}
      <Dialog
        fullScreen
        fullWidth
        open={isFocused}
        TransitionComponent={Fade}
        transitionDuration={1000}
      >
        <div
          id="content-container"
          className="bxShadow"
          style={{
            backgroundColor: "white",
            height: 500,
            padding: "28px 24px",
            height: "auto",
            marginBottom: "0%",
          }}

        >
          {
            showSkeliton ?

              <Skeliton /> : <><div style={{ display: "flex", alignItems: "center" }}>
                <Typography variant="h1">
                  {i18n().menu_Instandhaltung_submenu2}
                </Typography>

                <Link
                  className="btn-submit"
                  to={"/create-notification"}
                  style={{ marginLeft: "2%" }}
                  state={{
                    notification: "",
                    equip: "",
                    equip_pool: "",
                    date: "",
                    time: "",
                    pageType: "create",
                    from: "aufgabe"
                  }}
                >
                  <Button variant="contained" startIcon={<Add />}>
                    {" "}
                    Neu{" "}
                  </Button>
                </Link>

                <div className="dnd_viewmode">
                  <ButtonGroup
                    variant="outlined"
                  >
                    <Button
                      startIcon={
                        <KompactSvg
                          backgroundColor={viewMode === "c" ? "#FFFFFF" : "#0F3F51"}
                          className={viewMode === "c" ? "dnd_groupButton_active_c" : "dnd_groupButton_c"}
                        />
                      }
                      onClick={() => setViewMode("c")}
                      variant={viewMode === "c" ? "contained" : "outlined"}
                      color="primary"
                    >kompakt</Button>

                    <Button
                      startIcon={
                        <DetailsSvg
                          backgroundColor={viewMode === "d" ? "#FFFFFF" : "#0F3F51"}
                          className={viewMode === "d" ? "dnd_groupButton_active_d" : "dnd_groupButton_d"}
                        />
                      }
                      onClick={() => setViewMode("d")}
                      variant={viewMode === "d" ? "contained" : "outlined"}
                      color="primary"
                    >Details</Button>

                  </ButtonGroup>

                  <Button onClick={() => { setIsFocused(!isFocused) }} variant="outlined" sx={{ marginLeft: 4 }} startIcon={isFocused ? <StandardSvg /> : <FokusSvg />}> {isFocused ? "Standard" : "Fokus"} </Button>
                </div>



              </div>

                <br />

                <Grid container spacing={3} style={{ marginTop: 0 }}>
                  <Grid
                    item
                    xs={12}
                    sx={{ paddingTop: "15px !important", display: "flex" }}
                  >
                    {/* <Grid xs={4}>
                      <AreaPoolFilter
                        areaPoolFilterValue={areaPoolFilterValue}
                        setAreaPoolFilterValue={setAreaPoolFilterValue}
                       
                      />
                    </Grid> */}

                    <Grid xs={6}>
                      <NotificationTypesFilter
                        setFilterNotificationTypes={setFilterNotificationTypes}
                        FilterNotificationTypes={FilterNotificationTypes}
                        isFocused={isFocused}
                      />
                    </Grid>
                    <Grid xs={0.2}></Grid>

                    <Grid xs={5.8}>
                      <UsersFilter
                        userFilter={userFilter}
                        setUserFilter={setUserFilter}
                        users={props.users}
                        isFocused={isFocused}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br></br>
                <Grid container spacing={3} style={{ marginTop: 0 }}>
                  <Grid item xs={12} sx={{ paddingTop: "15px !important" }}>
                    <SortableDragAndDrop
                      areaPoolFilter={areaPoolFilterValue}
                      notificationTypesFilter={FilterNotificationTypes}
                      userFilter={userFilter}
                      showEquipment={viewMode === "d"}
                      isFocused={isFocused}
                    />
                  </Grid>
                </Grid>
              </>}
        </div>
      </Dialog>

      <div
        id="content-container"
        className="bxShadow"
        style={{
          backgroundColor: "white",
          height: 500,
          padding: "28px 24px",
          height: "auto",
          marginBottom: "10%",
        }}
      >
        {
          showSkeliton ?

            <Skeliton /> : <><div style={{ display: "flex", alignItems: "center" }}>
              <Typography variant="h1">
                {i18n().menu_Instandhaltung_submenu2}
              </Typography>

              <Link
                className="btn-submit"
                to={"/create-notification"}
                style={{ marginLeft: "2%" }}
                state={{
                  notification: "",
                  equip: "",
                  equip_pool: "",
                  date: "",
                  time: "",
                  pageType: "create",
                  from: "aufgabe"
                }}
              >
                <Button variant="contained" startIcon={<Add />}>
                  {" "}
                  Neu{" "}
                </Button>
              </Link>

              <div className="dnd_viewmode">
                <ButtonGroup
                  variant="outlined"
                >
                  <Button
                    startIcon={
                      <KompactSvg
                        backgroundColor={viewMode === "c" ? "#FFFFFF" : "#0F3F51"}
                        className={viewMode === "c" ? "dnd_groupButton_active_c" : "dnd_groupButton_c"}
                      />
                    }
                    onClick={() => setViewMode("c")}
                    variant={viewMode === "c" ? "contained" : "outlined"}
                    color="primary"
                  >kompakt</Button>

                  <Button
                    startIcon={
                      <DetailsSvg
                        backgroundColor={viewMode === "d" ? "#FFFFFF" : "#0F3F51"}
                        className={viewMode === "d" ? "dnd_groupButton_active_d" : "dnd_groupButton_d"}
                      />
                    }
                    onClick={() => setViewMode("d")}
                    variant={viewMode === "d" ? "contained" : "outlined"}
                    color="primary"
                  >Details</Button>

                </ButtonGroup>

                <Button onClick={() => { setIsFocused(!isFocused) }} variant="outlined" sx={{ marginLeft: 4 }} startIcon={isFocused ? <StandardSvg /> : <FokusSvg />}> {isFocused ? "Standard" : "Fokus"} </Button>
              </div>



            </div>

              <br />

              <Grid container spacing={3} style={{ marginTop: 0 }}>
                <Grid
                  item
                  xs={12}
                  sx={{ paddingTop: "15px !important", display: "flex" }}
                >
                  <AreaPoolFilter
                    areaPoolFilterValue={areaPoolFilterValue}
                    setAreaPoolFilterValue={setAreaPoolFilterValue}
                    isFocused={isFocused}
                  />

                  <NotificationTypesFilter
                    setFilterNotificationTypes={setFilterNotificationTypes}
                    FilterNotificationTypes={FilterNotificationTypes}
                    isFocused={isFocused}
                  />

                  <UsersFilter
                    userFilter={userFilter}
                    setUserFilter={setUserFilter}
                    users={props.users}
                    isFocused={isFocused}
                  />
                </Grid>
              </Grid>
              <br></br>
              <Grid container spacing={3} style={{ marginTop: 0 }}>
                <Grid item xs={12} sx={{ paddingTop: "15px !important" }}>
                  <SortableDragAndDrop
                    areaPoolFilter={areaPoolFilterValue}
                    notificationTypesFilter={FilterNotificationTypes}
                    userFilter={userFilter}
                    showEquipment={viewMode === "d"}
                  />
                </Grid>
              </Grid>
            </>}
      </div>
    </>
  );
});
